<template>
  <div class="d-none">
    <BaseTable
      class="actions-table"
      :items="items"
      :fields="fields"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      @sort-changed="onSortChanged"
    >
      <template #cell(actions)="slotProps">
        <a href="#" @click.prevent="info(slotProps.data.item, slotProps.data.index)" class="mr-2">Link</a>
        <a href="#" class="mr-2" @click.prevent="toggleDetails(slotProps.data.index)">Edit</a>
        <a class="help-text" href="#" title="Tooltip!">
          Delete
          <i class="fa-regular fa-circle-question"></i>
        </a>
      </template>

      <template #cell(status)="slotProps">
        <span v-html="getStatusHtml(slotProps.data.value)"></span>
      </template>
    </BaseTable>

    <div v-for="(item, idx) in items" :key="`details-${idx}`">
      <div v-if="detailsOpen[idx]" class="card p-3 mt-2">
        <ul class="mb-0">
          <li v-for="(value, key) in item" :key="key">{{ key }}: {{ value }}</li>
        </ul>
      </div>
    </div>

    <BaseModal v-model="showInfoModal" :title="infoModal.title" ok-only>
      <pre>{{ infoModal.content }}</pre>
    </BaseModal>
  </div>
</template>

<script>
import BaseModal from '../base/BaseModal.vue'
import BaseTable from '../base/BaseTable.vue'

export default {
  name: 'StyleGuideTable',
  components: {
    BaseModal,
    BaseTable
  },
  data () {
    return {
      items: [
        { code: 'E660', type: 'Online', status: false, email: 'test@test.se', name: { first: 'Mitzi', last: 'Navarro' } },
        { code: 'E660', type: 'Online', status: false, email: 'test@test.se', name: { first: 'Genevieve', last: 'Wilson' } },
        { code: 'E660', type: 'Online', status: true, email: 'test@test.se', name: { first: 'John', last: 'Carney' }, _cellVariants: { status: 'danger' } },
        { code: 'E660', type: 'Online', status: false, email: 'test@test.se', name: { first: 'Dick', last: 'Dunlap' } }
      ],
      fields: [
        { key: 'code', label: 'Code', sortable: true, sortDirection: 'desc' },
        { key: 'email', label: 'E-mail', sortable: true, class: 'email-column' },
        { key: 'type', label: 'Form Type', sortable: true },
        { key: 'status', label: 'Status', sortable: true, sortByFormatted: true, filterByFormatted: true },
        { key: 'actions', label: 'Actions', class: 'action-column' }
      ],
      sortBy: '',
      sortDesc: false,
      showInfoModal: false,
      infoModal: {
        title: '',
        content: ''
      },
      detailsOpen: {}
    }
  },
  methods: {
    info (item, index) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.showInfoModal = true
    },
    toggleDetails (index) {
      this.$set(this.detailsOpen, index, !this.detailsOpen[index])
    },
    getStatusHtml (value) {
      return !value ? 'Sent' : 'Not sent <a class="ml-1">Send invitation</a>'
    },
    onSortChanged ({ sortBy, sortDesc }) {
      this.sortBy = sortBy
      this.sortDesc = sortDesc
    }
  }
}
</script>

<style>
  .email-column {
    width: 100%;
  }
  .table thead th {
    white-space: nowrap;
  }
  .table tbody td {
    white-space: nowrap;
  }
  .table tbody td.email-column {
    width: auto;
  }
</style>
